import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { NoteInterface } from '../../models/note.interface';
import { NotesService } from '../../services/notes.service';
import { EDisplayNotesActions, UpdateDisplayNotesVisibility } from '../../store/actions/display-notes.actions';
import { Actions, ofType } from '@ngrx/effects';
import { ConstsHelper } from '../../../../helpers/consts.helper';

@Component({
  selector: 'app-notes-popup',
  templateUrl: './notes-popup.component.html',
  styleUrls: ['./notes-popup.component.css'],
  standalone: false
})
export class NotesPopupComponent implements OnInit {

  isVisible: boolean;
  submitForm: boolean;
  result: NoteInterface = null;
  displayMessageError: boolean;
  note: string;
  ConstsHelper = ConstsHelper;
  constructor(
      private store: Store<any>,
      private action$: Actions,
      private notesService: NotesService
  ) {}
  ngOnInit() {
    this.note = '';
    this.isVisible = false;
    this.submitForm = false;
    this.action$.pipe(ofType(EDisplayNotesActions.UpdateDisplayNotesVisibility)).subscribe((response: UpdateDisplayNotesVisibility) => {
      if (response != null) {
        this.result = response.payload;
        this.isVisible = true;
      } else {
        this.isVisible = false;
      }
    });
  }

  checkNoteEmpty() {
    this.displayMessageError = this.note === '';
  }

  close() {
    this.isVisible = false;
  }
  submit() {
    this.displayMessageError = false;
    if (this.note.length === 0) {
      this.displayMessageError = true;
    } else if (!this.submitForm) {
      this.submitForm = true;
      this.notesService.save(this.result.oid, this.result.category, this.note).subscribe(
          response => {
            this.isVisible = false;
            this.submitForm = false;
            this.note = '';
          }
      );
    }
  }
}
